<mat-card
  class="__info"
  [ngClass]="{
    'is-orange': color() === 'orange',
    'is-green': color() === 'green',
    'is-base': color() === 'base'
  }">

  <h3 class="fx:text-center __title">Prepare records at your DNS provider</h3>

  @if (showDesc()) {
    <p class="u-desc  fx:text-center  fx:pt-0-25">
      <zui-docs-text>
        Configure your <a data-zui-new-docs="references/networking/dns">DNS records</a> to point your domain to Zerops.
        You can do this step <strong>before or after you fill in the form below</strong>, <br/>recods must be set <strong>for each of the domains</strong> you add.
      </zui-docs-text>
    </p>
  }

  <mat-button-toggle-group
    class="__mode-toggles  fx:pt-1"
    (valueChange)="selectedCard.set($event)"
  >
    <mat-button-toggle
      class="__routing-button"
      value="CNAME"
      [checked]="true">

      <h4 class="__mode-toggles_name">CNAME</h4>

      <p class="__description">
        Use for non-apex domains or with DNS providers supporting apex CNAME (Cloudflare etc.)
      </p>

      <zui-separator
        class="__toggle-separator"
        position="center"
        orientation="vertical"
        size="medium"
        spacing="none"
      />

    </mat-button-toggle>

    <mat-button-toggle
      class="__addon-button"
      value="AAAA">

      <h4 class="__mode-toggles_name">A / AAAA</h4>

      <p class="__description">
        Standard DNS using unique IPv6 and either paid unique, or free shared IPv4
      </p>

      <zui-separator
        class="__toggle-separator"
        position="center"
        orientation="vertical"
        size="medium"
        spacing="none"
      />

    </mat-button-toggle>

    <div>
      <mat-icon class="__mode-icon">add</mat-icon>
    </div>

    <mat-button-toggle
      class="__addon-button  __addon-button--wildcard"
      value="WILDCARD">

      <h4 class="__mode-toggles_name">Wildcard</h4>

      <p class="__description">
        <strong>Additional DNS configuration</strong> when your domain field contains a&nbsp;domain with a&nbsp;wildcard
      </p>

      <zui-separator
        class="__toggle-separator"
        position="center"
        orientation="vertical"
        size="medium"
        spacing="none"
      />

    </mat-button-toggle>


  </mat-button-toggle-group>

  @switch (selectedCard()) {
    @case ('CNAME') {

      <div class="__ip-card-table">

        <div class="__header">Type</div>
        <div class="__header">Name</div>
        <div class="__header">Value</div>

        <div class="__body fx:font-medium">CNAME</div>
        <div class="__body fx:font-medium"><strong class="__highlight">xxx</strong></div>
        <div class="__body fx:font-medium">
          <zef-copy-to-clipboard
            mode="basic"
            [copyData]="publicZone()"
            tooltip="Copy CNAME to clipboard">
            {{ publicZone() }}
          </zef-copy-to-clipboard>
        </div>

      </div>

      <p class="__desc">
        <zui-docs-text>

          <div class="__desc-group">
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            Replace <strong class="__highlight">xxx</strong> with hostname of your domain: <strong>&#64;</strong> for root (example.com) and <strong>foo</strong> (foo.example.com) for subdomain.
          </div>

          <div
            [class.__desc-group--last]="ipV4()"
            class="__desc-group">
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            If you are setting up Apex / root domain and you DNS provider doesn't allow root hostnames (&#64;) to have CNAME records, use the <strong (click)="selectedCard.set('AAAA')">A / AAAA option</strong>.
          </div>

          @if (!ipV4()) {

            <div class="__desc-group  __desc-group--last">
              <mat-icon fontSet="material-icons-outlined">info</mat-icon>
              If you want to route domains through <a data-zui-new-docs="references/networking/cloudflare">Cloudflare</a>, you need to <strong>exclude</strong> the shared IPv4 address from the CNAME record (will affect CNAME for the whole project).
            </div>

            <z-shared-ipv4
              [projectId]="projectId()"
              class="__ipv4-toggle-slider"
            />
          }

        </zui-docs-text>
      </p>

    }

    @case ('AAAA') {

      <div class="__ip-card-table">

        <div class="__header">Type</div>
        <div class="__header">Name</div>
        <div class="__header">Value</div>

        <div class="__body fx:font-medium">AAAA</div>
        <div class="__body fx:font-medium"><strong class="__highlight">xxx</strong></div>
        <div class="__body fx:font-medium">
          <zef-copy-to-clipboard
            mode="basic"
            [copyData]="ipV6()"
            tooltip="Copy IPv6 address to clipboard">
            {{ ipV6() }}
          </zef-copy-to-clipboard>
        </div>

        <div class="__body fx:font-medium">A</div>
        <div class="__body fx:font-medium"><strong class="__highlight">xxx</strong></div>
        <div class="__body fx:font-medium">
          @if (ipV4()) {
            <zef-copy-to-clipboard
              mode="basic"
              [copyData]="ipV4()"
              tooltip="Copy IPv4 address to clipboard">
              {{ ipV4() }}
            </zef-copy-to-clipboard>
          } @else {
            <zef-copy-to-clipboard
              mode="basic"
              [copyData]="sharedIpV4()"
              tooltip="Copy shared IPv4 address to clipboard">
              {{ sharedIpV4() }}
            </zef-copy-to-clipboard>
            <span class="__tag fx:ml-0-25">Shared</span>
          }
        </div>

        @if (!ipV4()) {
          <div class="__body fx:font-medium"></div>
          <div class="__body fx:font-medium"></div>
          <div class="__body fx:font-medium">
            @if (ipV4PendingRequest()) {
              <span class="__pending">IPv4 assignment request is pending</span>
            }
            @if (!ipV4PendingRequest()) {
              <div
                [matTooltip]="requestIpV4DisabledTooltip()"
                [matTooltipDisabled]="!requestIpV4Disabled()">
                <zef-progress-error
                  class="__ip-button"
                  [key]="requestIpv4Key()"
                  full
                  [disabled]="requestIpV4Disabled() || !ipV4Addon()"
                  [loading]="ipV4AddonInProcess()">
                  <button
                    mat-button
                    type="button"
                    [disabled]="requestIpV4Disabled() || !ipV4Addon()"
                    (click)="requestIpV4.emit()"
                    [class.is-single]="showOnlyIpV4Button()"
                    [class.c-button--smaller]="!showOnlyIpV4Button()"
                    class="__ip-request-button">
                    @if (showOnlyIpV4Button()) {
                      <mat-icon>router</mat-icon>&nbsp;
                    }<span>{{ requestIpV4ButtonText() }}</span>

                  </button>
                </zef-progress-error>
              </div>
            }
          </div>
        }

      </div>

      <p class="__desc">
        <zui-docs-text>

          <div class="__desc-group">
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            Replace <strong class="__highlight">xxx</strong> with hostname of your domain: <strong>&#64;</strong> for root (example.com) and <strong>foo</strong> (foo.example.com) for subdomain.
          </div>

          <div class="__desc-group">
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>

            Set either AAAA (IPv6 traffic only) or A (IPv4 traffic only), or both records to point to IP addresses shown above.
            @if (!ipV4()) {
              <strong>When using shared IPv4 address for A&nbsp;record, AAAA record is required.</strong>
              Shared IPv4 can only be used for HTTP traffic and is subject to the limitations explained <a href="https://docs.zerops.io/features/access#shared-ipv4-address-free" target="_blank" rel="noopener noreferrer">here</a>.
            }
          </div>

          <div class="__desc-group  __desc-group--last">
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>

            When using <strong>Cloudflare</strong>, you only need to set the AAAA record with proxy enabled, Cloudflare handles IPv4 translation internally.
            More on Cloudflare setup can be found in our <a href="https://docs.zerops.io/references/networking/cloudflare" target="_blank" rel="noopener noreferrer">docs</a>.
          </div>

        </zui-docs-text>
      </p>

    }

    @case ('WILDCARD') {
      <div class="__ip-card-table __ip-card-table--wildcard">
        <div class="__header">Type</div>
        <div class="__header">Name</div>
        <div class="__header">Value</div>

        <div class="__body fx:font-medium">CNAME</div>
        <div class="__body fx:font-medium">*</div>
        <div class="__body fx:font-medium">
          <zef-copy-to-clipboard
            mode="basic"
            [copyData]="'example.com'"
            tooltip="Copy value to clipboard">
            <strong class="__highlight">example.com</strong>
          </zef-copy-to-clipboard>
        </div>

        <div class="__body fx:font-medium">CNAME</div>
        <div class="__body fx:font-medium">_acme-challenge</div>
        <div class="__body fx:font-medium">
          <zef-copy-to-clipboard
            mode="basic"
            [copyData]="'example.com.zerops.zone'"
            tooltip="Copy value to clipboard">
            <strong class="__highlight">example.com</strong>.zerops.zone
          </zef-copy-to-clipboard>
        </div>
      </div>

      <p class="__desc">
        <zui-docs-text>
          <div class="__desc-group  __desc-group--last">
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>

            Replace <strong class="__highlight">example.com</strong> with your actual wildcard domain.
            Find out more about wildcard domain configuration <a href="https://docs.zerops.io/references/networking/dns#wildcard-domain-configuration" target="_blank" rel="noopener noreferrer">here</a>.
          </div>
        </zui-docs-text>
      </p>

    }
  }

</mat-card>
